import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";

export const fetchReports = createAsyncThunk(
  "report/fetchReports",
  async (queryParams = {}, { getState }) => {
    const { report } = getState();
    const response = await axiosInstance.get("/report", {
      params: {
        ...queryParams,
        page: report.page,
        limit: report.limit,
      },
    });
    return response.data;
  }
);
export const fetchBookwiseReport = createAsyncThunk(
  "report/fetchBookwiseReport",
  async ({ from, to }) => {
    // Ensure both 'from' and 'to' are provided
    if (!from || !to) {
      throw new Error("Both 'from' and 'to' book numbers must be provided.");
    }

    const response = await axiosInstance.get("api/report/bookwise", {
      params: { from, to },
    });
    return response.data;
  }
);

export const fetchBookwisePayModeReport = createAsyncThunk(
  "report/fetchBookwisePayModeReport",
  async ({ from, to }) => {
    if (!from || !to) {
      throw new Error("Both 'from' and 'to' book numbers must be provided.");
    }
    const response = await axiosInstance.get("api/report/bookwise-paymode", {
      params: { from, to },
    });
    return response.data;
  }
);

export const fetchBookwisePayModeWiseReport = createAsyncThunk(
  "report/fetchBookwisePayModeWiseReport",
  async ({ from, to, payMode }) => {
    if (!from || !to || !payMode) {
      throw new Error("From, to, and payMode must be provided.");
    }
    const response = await axiosInstance.get(
      "api/report/bookwise-paymodewise",
      {
        params: { from, to, payMode },
      }
    );
    return response.data;
  }
);

const reportSlice = createSlice({
  name: "report",
  initialState: {
    reports: [],
    bookwiseReport: [],
    bookwisePayModeReport: [],
    overallReport: [],
    loading: false,
    error: null,
    page: 1,
    limit: 10,
  },
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setLimit(state, action) {
      state.limit = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // All Reports
      .addCase(fetchReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload;
      })
      .addCase(fetchReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Bookwise Report
      .addCase(fetchBookwiseReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookwiseReport.fulfilled, (state, action) => {
        state.loading = false;
        state.bookwiseReport = action.payload;
      })
      .addCase(fetchBookwiseReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Bookwise PayMode Report
      .addCase(fetchBookwisePayModeReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookwisePayModeReport.fulfilled, (state, action) => {
        state.loading = false;
        state.bookwisePayModeReport = action.payload;
      })
      .addCase(fetchBookwisePayModeReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Bookwise PayMode Wise Report
      .addCase(fetchBookwisePayModeWiseReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookwisePayModeWiseReport.fulfilled, (state, action) => {
        state.loading = false;
        state.bookwisePayModeReport = action.payload;
      })
      .addCase(fetchBookwisePayModeWiseReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setPage, setLimit } = reportSlice.actions;
export default reportSlice.reducer;
